module.exports = __webpack_public_path__ + "static/assets/a2fcb6bdb243f00f5ee67b51fae60660.svg";